import { useEffect } from "react"

const useResizeWindow = (cb: () => void) => {

  useEffect(() => {
    window.addEventListener('resize', cb)
    return () => window.removeEventListener('resize', cb)
  }, [])
}

export default useResizeWindow